// extracted by mini-css-extract-plugin
export default {"radio":"radio_radio__GMe+t","radio_label":"radio_radio_label__LPZX5"};